module.exports = __webpack_public_path__ + "img/6-diccionary.9c324c69.svg";